import React, { Fragment } from "react";
import moment from "moment";
import numberFormatter from "utils/numberFormatter";
import { Grid } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import Fade from "@material-ui/core/Fade";
import hedgeTypes from "constants/hedgeTypes";

import { MakeWholeResult, YieldMaintenanceTraditionalResult, DefeasanceResult, YieldMaintenanceAgencyStyleResult, AggregateInterestResult, PaymentDateOnly } from "../../Calculators/Prepayment/AnalysisDetailVariants";

import { BlueResult, FancyDivider, PrimaryDataWrapper, AddRow, AddIconWrapper, VerticalSpace, Disclosure, AdditionalInfoButton, AdditionalInformationWrapper, FlexContainer, StyledDialogIconButton, StyledButtonWithPadding } from "./styles";
import { BlueBox, PrimaryData, PrimaryDataCenter, Date } from "./CommonUtil";

class PrepaymentAnalysisResult extends React.Component {
  render() {
    const { prepaymentResult, isAdditionalInfoOpen } = this.props;

    if (!prepaymentResult) {
      return null;
    }

    const shouldIncludeAccruedInterest = false; // Added per US10409
    const errorMessage = !prepaymentResult ? null : prepaymentResult.errorMessage;
    const isOverview = !prepaymentResult ? null : prepaymentResult.isOverview;
    const isLoan = !prepaymentResult ? null : prepaymentResult.isLoan;
    const prepaymentType = !prepaymentResult ? null : prepaymentResult.prepaymentType;
    const prepaymentCost = !prepaymentResult ? null : prepaymentResult.prepaymentCost;
    const prepaymentPenalty = !prepaymentResult ? null : prepaymentResult.prepaymentPenalty;
    const accruedInterest = !shouldIncludeAccruedInterest || !prepaymentResult ? null : prepaymentResult.accruedInterest;
    const balanceAtPrepayment = !prepaymentResult ? null : prepaymentResult.balanceAtPrepayment;
    const totalDueToLender = !prepaymentResult ? null : prepaymentResult.totalDueToLender;
    const makeWholeResult = !prepaymentResult ? null : prepaymentResult.makeWholeResult;
    const yieldMaintenanceResult = !prepaymentResult ? null : prepaymentResult.yieldMaintenanceResult;
    const yieldMaintenanceAgencyStyleResult = !prepaymentResult ? null : prepaymentResult.yieldMaintenanceAgencyStyleResult;
    const defeasanceResult = !prepaymentResult ? null : prepaymentResult.defeasanceResult;
    const aggregateInterestResult = !prepaymentResult ? null : prepaymentResult.aggregateInterestResult;
    const spreadMaintenanceResult = !prepaymentResult ? null : prepaymentResult.spreadMaintenanceResult;
    const flatPercentageSchedule = !prepaymentResult ? null : prepaymentResult.flatPercentageSchedule;

    const isHedge = !prepaymentResult ? null : prepaymentResult.isHedge;
    const markToMarket = !prepaymentResult ? null : prepaymentResult.markToMarket;
    const allInRate = !prepaymentResult ? null : prepaymentResult.allInRate;
    const pv01 = !prepaymentResult ? null : prepaymentResult.pv01;
    const notional = !prepaymentResult ? null : prepaymentResult.notional;
    const strike = !prepaymentResult ? null : prepaymentResult.strike;
    const terminationDate = !prepaymentResult ? null : prepaymentResult.terminationDate;
    const midRate = !prepaymentResult ? null : prepaymentResult.midRate;
    const hedgeTypeId = !prepaymentResult ? null : prepaymentResult.hedgeTypeId;

    return (
      <>
        <BlueResult>
          {!isAdditionalInfoOpen &&
          (<Fade in={!isAdditionalInfoOpen}>
            <PrimaryDataWrapper>
              {errorMessage && <PrimaryDataCenter value={errorMessage} label="" />}
              {(isOverview || isLoan) && (<>
                {prepaymentType !== null && <PrimaryDataCenter value={prepaymentType.replace(/_/g, " ")} label="" />}
                {prepaymentCost !== null && <BlueBox value={numberFormatter.formatMoney(prepaymentCost, 2)} label="Prepayment Cost" />}
                {prepaymentPenalty !== null && <PrimaryData value={numberFormatter.formatMoney(prepaymentPenalty, 2)} label="Prepayment Penalty" />}
                {accruedInterest !== null && <PrimaryData value={numberFormatter.formatMoney(accruedInterest, 2)} label="Accrued Interest" />}
                {balanceAtPrepayment !== null && <AddRow>
                  <AddIconWrapper><Add fontSize="inherit" /></AddIconWrapper>
                  <PrimaryData value={numberFormatter.formatMoney(balanceAtPrepayment, 2)} label="Balance at prepayment" />
                                                 </AddRow>}
                <FancyDivider />
                {totalDueToLender !== null && <PrimaryData value={numberFormatter.formatMoney(totalDueToLender, 2)} label="total due to lender" />}
              </>) }

              {isHedge && (<>
                {markToMarket !== null && <BlueBox value={numberFormatter.formatMoney(markToMarket, 2)} label="Mark to Market" />}

                {hedgeTypeId != null && hedgeTypeId == hedgeTypes.CAP && notional !== null && <PrimaryDataCenter value={numberFormatter.formatMoney(notional, 2)} label="Notional" />}
                {hedgeTypeId != null && hedgeTypeId == hedgeTypes.CAP && strike !== null && <PrimaryDataCenter value={numberFormatter.formatRate(strike, 2)} label="Strike" />}
                {hedgeTypeId != null && hedgeTypeId == hedgeTypes.CAP && terminationDate !== null && <Date value={moment(terminationDate).format("MM/DD/YYYY")} label="Termination Date" />}

                {hedgeTypeId != null && hedgeTypeId == hedgeTypes.SWAP && allInRate !== null && <PrimaryDataCenter value={numberFormatter.formatRate(allInRate, 2)} label="All-In Rate" />}
                {hedgeTypeId != null && hedgeTypeId == hedgeTypes.SWAP && pv01 !== null && <PrimaryDataCenter value={numberFormatter.formatMoney(pv01, 2)} label="PV01" />}
                {hedgeTypeId != null && hedgeTypeId == hedgeTypes.SWAP && midRate !== null && <PrimaryDataCenter value={numberFormatter.formatRate(midRate, 2)} label="Mid Rate" />}
                           </>)}
            </PrimaryDataWrapper>
           </Fade>)}

          {isAdditionalInfoOpen &&
            (<Fade in={isAdditionalInfoOpen}>
              <AdditionalInformationWrapper>
                <FlexContainer>
                  <Grid container justify="space-between">
                    {makeWholeResult && <MakeWholeResult result={makeWholeResult} />}
                    {yieldMaintenanceResult && <YieldMaintenanceTraditionalResult result={yieldMaintenanceResult} />}
                    {yieldMaintenanceAgencyStyleResult && <YieldMaintenanceAgencyStyleResult result={yieldMaintenanceAgencyStyleResult} />}
                    {defeasanceResult && <DefeasanceResult result={defeasanceResult} />}
                    {aggregateInterestResult && <AggregateInterestResult result={aggregateInterestResult} />}
                    {(spreadMaintenanceResult || flatPercentageSchedule) && <PaymentDateOnly result={prepaymentResult} />}
                  </Grid>
                </FlexContainer>
              </AdditionalInformationWrapper>
             </Fade>)}

          {isLoan && (!errorMessage || errorMessage === "") && (<VerticalSpace>
            <AdditionalInfoButton onClick={this.props.toggleAdditionalInfo}>{this.props.additionalInfoButtonText}</AdditionalInfoButton>
          </VerticalSpace>)}
        </BlueResult>
        <Disclosure>Calculations are for informational purposes and subject to change with market conditions. These calculations are based on the next payment date.</Disclosure>
      </>
    );
  }
}

export default PrepaymentAnalysisResult;
